import React from 'react'
import { Typography } from 'antd'
import { CompletedPurchaseOrder } from '../../../types/purchaseOrder'

const { Text } = Typography

interface Props {
  purchaseOrder: CompletedPurchaseOrder
}

export const PurchaseOrderDetails: React.FC<Props> = ({ purchaseOrder }) => {
  const { supplier, deliveryAddress, deliveryInstructions, contact } = purchaseOrder

  return (
    <div className="grid grid-cols-2 gap-8 mb-8">
      <div>
        <Text strong className="block mb-2">
          Supplier
        </Text>
        <Text className="block">{supplier.name}</Text>
        <Text className="block whitespace-pre-line">{supplier.address}</Text>
        {supplier.contact && (
          <>
            <Text className="block">{supplier.contact.name}</Text>
            <Text className="block">{supplier.contact.email}</Text>
            <Text className="block">{supplier.contact.phone}</Text>
          </>
        )}
      </div>

      <div>
        {deliveryAddress && (
          <>
            <Text strong className="block mb-2">
              Delivery Details
            </Text>
            <Text className="block whitespace-pre-line">{deliveryAddress}</Text>
          </>
        )}
        {deliveryInstructions && (
          <>
            <Text strong className="block mt-4 mb-2">
              Notes
            </Text>
            <Text className="block whitespace-pre-line">{deliveryInstructions}</Text>
          </>
        )}

        {contact && (
          <>
            <Text strong className="block mt-4 mb-2">
              Contact Person
            </Text>
            <Text className="block">{contact.name}</Text>
            <Text className="block">{contact.email}</Text>
            <Text className="block">{contact.phone}</Text>
          </>
        )}
      </div>
    </div>
  )
}
